<template>
    <div>  
        <h2>{{user.person.firstName}} shops</h2>
        <vue-table ref="table" :useSearch="true"
            :dataTable="shops"
            :tableFields="shopsTableFields"
            :defaultSortOrder="[sortOrder]">

        </vue-table>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Table from '../../../components/Panel/Table/Table';
import ShopsTableFields from '../../../utilities/tablesProperties/ShopsTableFields';

export default {
    name: 'user-shops',
    data () {
        return {
            shops: [],
            user: null,
            shopsTableFields: ShopsTableFields,
            sortOrder: {
                field: 'name',
                direction: 'asc'
            }
        };
    },
    components: {
        'vue-table': Table
    },
    async created () {
        this.GetUserShopList({ id: this.$route.params.id })
            .then(() => this.fetchShops()).catch(err => console.log(err));
        this.user = this.getUsers.find(user => user.id = this.$route.params.id);
    },
    computed: {
        ...mapGetters({
            getUserShops: 'getUserShops',
            getUsers: 'getUsers'
        })
    },
    methods: {
        ...mapActions([
            'GetUserShopList',
            'GetShopById'
        ]),
        async fetchShops () {
            try {
                let data = await this.getUserShops;
                this.shops = data ? this.$utils.flatten(
                    await this.$utils.resolvePromises(
                        data.filter(item => item)
                            .map(shop => this.GetShopById(shop))
                    )) : [];
            } catch (err) {
                console.log(err);
            }
        }
    }
};
</script>